<template>
  <div class="container" style="height: 100%">
    <div class="top">
      <div class="back_box">
        <!-- <img src="@/assets/images/icons/icon_back.png" alt="" /> -->
        <el-button
          class="back-btn"
          type="text"
          icon="el-icon-arrow-left"
          @click="$router.go(-1)"
          >返回</el-button
        >
      </div>
      <div class="info">
        <p class="title">{{ info.name }}</p>
        <p style="margin-top: 5px">
          <span class="time">{{
            formatDate(info.startTime, "MM-DD HH:mm")
          }}</span>
          <span class="shu">|</span>
          <span class="surplus" v-show="info.autoStop && info.status != 'STOP'"
            >剩余<i class="el-icon-time"></i>{{ surplus }}</span
          >
          <span class="end" v-show="info.status == 'STOP'">已结束</span>
        </p>
        <div class="right_btns">
          <!-- <el-button type="text">导出数据</el-button> -->
          <el-button
            type="text"
            v-show="info.status != 'STOP'"
            @click="handleStop"
            >结束活动</el-button
          >
        </div>
      </div>
    </div>
    <div class="main">
      <el-tabs type="border-card" v-model="activeName">
        <el-tab-pane :label="'已签' + signedList.length" name="1">
          <div
            class="one"
            v-for="item in signedList"
            :key="item.userId"
            @click="handleClick(item.userId)"
          >
            <el-image class="img" :src="item.avatar" fit="cover"></el-image>
            <div class="right">
              <p class="name">{{ item.nickName }}</p>
              <p class="time">
                {{ formatDate(item.createTime, "MM-DD HH:mm") }}
              </p>
              <p class="status">{{ formatStatus(item.status) }}</p>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="'未签' + notList.length" name="2">
          <div
            class="one"
            v-for="item in notList"
            :key="item.userId"
            @click="handleClick(item.userId)"
          >
            <el-image class="img" :src="item.avatar" fit="cover"></el-image>
            <div class="right">
              <p class="name">{{ item.nickName }}</p>
              <!-- <p class="time">
                {{ formatDate(item.createTime, "MM-DD HH:mm") }}
              </p> -->
              <p class="status">{{ formatStatus(item.status) }}</p>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <el-dialog
      title="修改状态"
      :visible.sync="show"
      width="30%"
      center
      class="dialog"
    >
      <template v-for="item in statusList">
        <p
          class="one_state"
          v-if="!item.hide"
          :key="item.value"
          @click="editStatus(item.value)"
        >
          {{ item.label }}
        </p>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import mixinsData from "../mixins/detail";
import { signList, editSign } from "@/api/activity/sign";
import { formatDate } from "@/utils/index";
export default {
  name: "sign",
  mixins: [mixinsData],
  data() {
    return {
      formatDate,
      activeName: "1",
      signedList: [],
      notList: [],
      show: false,
      statusList: [
        { value: "SIGNED", label: "已签", hide: true },
        { value: "ABSENCE", label: "缺勤" },
        { value: "PERSONAL_LEAVE", label: "事假" },
        { value: "SICK_LEAVE", label: "病假" },
        { value: "LATE", label: "迟到" },
        { value: "LEAVE_EARLY", label: "早退" },
      ],
      currentId: null,
    };
  },
  methods: {
    // 签到列表
    getList() {
      let activityId = this.$route.query.activityId;
      // this.$loading.show();
      signList({ activityId }).then((res) => {
        // this.$loading.hide();
        if (res.code == 0) {
          this.signedList = res.data.filter((item) => {
            return item.status == "SIGNED";
          });
          this.notList = res.data.filter((item) => {
            return item.status != "SIGNED";
          });
        } else {
          console.log(res.msg);
        }
      });
    },
    formatStatus(status) {
      switch (status) {
        case "SIGNED":
          return "已签";
        case "ABSENCE":
          return "缺勤";
        case "PERSONAL_LEAVE":
          return "事假";
        case "SICK_LEAVE":
          return "病假";
        case "LATE":
          return "迟到";
        case "LEAVE_EARLY":
          return "早退";
        case "OVERDUE_SIGN":
          return "过期签到";
      }
    },
    handleClick(userId) {
      this.statusList[0].hide = this.activeName == 1;
      this.currentId = userId;
      this.show = true;
    },
    //修改签到状态
    editStatus(status) {
      editSign({
        userId: this.currentId,
        activityId: this.$route.query.activityId,
        status,
      }).then((res) => {
        if (res.code == 0) {
          this.show = false;
          this.$message.success("状态修改成功");
          this.getList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.top {
  margin-top: 30px;
  margin-bottom: 20px;
  width: 100%;
  text-align: left;
  .back_box {
    display: inline-block;
    width: calc(100% - 1126px);
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    img {
      width: 44px;
    }
    p {
      color: #969696;
      font-size: 16px;
    }
  }
  .info {
    position: relative;
    display: inline-block;
    padding: 24px 30px;
    background-color: #fff;
    width: 1126px;
    vertical-align: middle;
    .title {
      font-size: 16px;
      color: #333;
    }
    .time {
      margin-top: 5px;
      color: #999;
      font-size: 14px;
    }

    .shu {
      padding: 0 10px;
      color: #ddd;
    }
    .el-icon-time {
      margin: 0 5px;
    }
    .surplus {
      color: sandybrown;
    }
    .end {
      color: #999;
    }
    .right_btns {
      position: absolute;
      top: 50%;
      right: 30px;
      transform: translateY(-50%);
    }
  }
}

.main {
  height: calc(100% - 30px - 20px - 93px - 30px);
  overflow: auto;
  &::-webkit-scrollbar {
    width: 4px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    background-color: #c8c8c8;
  }

  ::v-deep .el-tabs {
    height: 100%;
    .el-tabs__content {
      padding: 0;
      height: calc(100% - 39px);
      text-align: left;
      overflow: auto;
      .one {
        position: relative;
        display: inline-block;
        width: 399px;
        border-right: 1px solid #ebebeb;
        height: 62px;
        padding: 9px 20px;
        border-bottom: 1px solid #ebebeb;
        .img {
          margin-right: 10px;
          width: 40px;
          height: 40px;
          cursor: pointer;
        }
        .right {
          display: inline-block;
          vertical-align: top;
          .name {
            font-size: 16px;
            color: #282828;
            cursor: pointer;
          }
          .time {
            margin-top: 5px;
            font-size: 12px;
            color: #999;
          }
          .status {
            position: absolute;
            right: 20px;
            top: 50%;
            transform: translateY(-50%);
            color: #999;
          }
        }
      }
    }
  }
}

::v-deep .dialog {
  .el-dialog__body {
    padding-left: 0;
    padding-right: 0;
  }
  .one_state {
    padding: 10px;
    font-size: 16px;
    text-align: center;
    transition: all 0.3s ease;
    cursor: pointer;
    &:hover {
      color: #fff;
      background-color: #409eff;
    }
  }
}
</style>